import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './kbaQuizScreen.module.css';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import ThemedButton from '../../components/ThemedButton';
import { KBA_QUESTIONS, KBA_SUBMIT } from '../../helper/constants';
import QuizHeader from './QuizHeader';

const KbaQuizScreen = ({ logo, steps }) => (
    <ScreenFrame
        logo={logo}
        header={<QuizHeader />}
        stepper={steps && <Stepper steps={steps} activeStep={1} />}
        footer={<ThemedButton>{KBA_SUBMIT}</ThemedButton>}
        bodyClassName={styles.body}
        footerClassName={styles.body}
    >
        {KBA_QUESTIONS.map(({ id, question, options, answer }) => (
            <Box key={id} className={styles.question}>
                <Typography className={styles.questionText}>{question}</Typography>
                {options.map((option) => (
                    <Box key={option} className={styles.option}>
                        <Box
                            className={clsx(styles.radio, option === answer && styles.radioChecked)}
                        />
                        <Typography className={styles.optionLabel}>{option}</Typography>
                    </Box>
                ))}
            </Box>
        ))}
    </ScreenFrame>
);

KbaQuizScreen.propTypes = {
    logo: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
};

export default KbaQuizScreen;
